import { REFRESH_TOKEN_EXPIRE_DAYS } from '@/constants';

const MS_PER_DAY = 24 * 60 * 60 * 1000;

const readExpClaim = (token: string): number | undefined => {
  try {
    const payload = token.split('.')[1];
    if (!payload) return undefined;
    // JWT segments are base64url: translate to base64 and pad before atob
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const { exp } = JSON.parse(atob(padded));
    return typeof exp === 'number' && Number.isFinite(exp) ? exp : undefined;
  } catch {
    return undefined;
  }
};

/**
 * Cookie expiry for a refresh token that pm_ums rotated: the token's own `exp` claim
 * (30 days for a registered user, 500 years for a guest), or 30 days when it cannot be read.
 * The payload is decoded without verification and used for the cookie lifetime only, never for an auth decision.
 */
export const getRefreshCookieExpiry = (refreshToken: string): Date => {
  const exp = readExpClaim(refreshToken);
  return exp === undefined ? new Date(Date.now() + REFRESH_TOKEN_EXPIRE_DAYS * MS_PER_DAY) : new Date(exp * 1000);
};
